module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-bar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-11 mt-1"
  }, [_c('erco-dropdown', {
    staticClass: "mr-sm-5 my-2 my-lg-0",
    attrs: {
      "label": "Status",
      "items": _vm.stati,
      "currentItemIndex": _vm.getIndexOf(_vm.currentStatus, _vm.stati)
    },
    on: {
      "change": _vm.handleStatiFilterChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    staticClass: "mr-sm-5 my-2 my-lg-0",
    attrs: {
      "label": "letzte Änderung",
      "items": _vm.editors,
      "currentItemIndex": _vm.getIndexOf(_vm.currentEditor, _vm.editors)
    },
    on: {
      "change": _vm.handleLastEditFilterChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    staticClass: "my-2 my-lg-0",
    attrs: {
      "label": "Rubrik",
      "items": _vm.categories,
      "currentItemIndex": _vm.getIndexOf(_vm.currentCategory, _vm.categories)
    },
    on: {
      "change": _vm.handleCategoryFilterChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('erco-cms-structure-dropdown', {
    staticClass: "cms-structure-dropdown float-right",
    attrs: {
      "dataset": _vm.cmsStructure
    },
    on: {
      "click": _vm.handleCmsStructureClick
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5bebeda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoStatusbar.vue
// module id = 673
// module chunks = 0